import Cookies from 'js-cookie';
import Cookie from './Cookie';

/**
 * Represents CookiesMgr
 */
class CookiesMgr {
	/**
	 * Get cookie
	 * @param {String} key - cookie key
	 * @returns {Cookie} - cookie
	 */
	getCookie(key: string): Cookie {
		return new Cookie(key, Cookies.get(key));
	};

	/**
	 * Set cookie value
	 * @param {Cookie} cookie - cookie
	 */
	setCookie(cookie: Cookie): void {
		Cookies.set(cookie.getKey(), cookie.getValue(), cookie.getAttributes());
	};

	/**
	 * Remove cookie value
	 * @param {String} key - cookie key
	 */
	removeCookie(key: string): void {
		Cookies.remove(key);
	}

	/**
	 * Get all cookies that match a regex or start with a specific prefix
	 * @param {RegExp | string} pattern - regex pattern or string prefix
	 * @returns {Cookie[]} - array of matching cookies
	 */
	getCookiesByPattern(pattern: RegExp | string): Array<Cookie> {
		if (typeof pattern === 'string') {
			pattern = new RegExp(pattern);
		}

		const allCookies = Cookies.get();
		const matchingCookies: Array<Cookie> = [];

		for (const key in allCookies) {
			if (pattern.test(key)) {
				matchingCookies.push(new Cookie(key, allCookies[key]));
			}
		}

		return matchingCookies;
	}
}

export default new CookiesMgr();
